module.exports = __webpack_public_path__ + "media/images/country_flags/ch-272cd91600cffead245b811f762d178f.png";